import styled from 'styled-components';
import { respondTo } from 'components/styles/_respondTo';

export const StyledFormBlockWrapper = styled.div`
  //display: none;
  ${respondTo.desktop`
    display: ${({ desktopDisplay = 'flex' }) => desktopDisplay};
    margin-left: ${({ desktopMl = 20 }) => desktopMl}px;
    // height: 100%;
  `}
  ${respondTo.mobile`
      align-items: inherit;
      display: ${({ mobileDisplay = 'flex' }) => mobileDisplay};
      box-shadow: ${({ showBorderMobile = true }) =>
        showBorderMobile && '0px 2px 4px 0px rgba(0, 0, 0, 0.1)'};
      min-height: ${({ minMobileH = '100px' }) => minMobileH};
      margin-top: ${({ mobileMt }) => mobileMt}px;
  `}
  flex: 1;
  //margin-top: 10px;
  border-radius: 6px;
  box-shadow: ${({ showBorderMobile = true }) =>
    showBorderMobile && '0px 2px 4px 0px rgba(0, 0, 0, 0.1)'};
  background-color: #ffffff;
  align-items: ${({ alignItems = 'flex-start' }) => alignItems};
  display: flex;
  justify-content: flex-start;
  width: 100%;
  min-height: ${({ minH = '100%' }) => minH};
`;

export const StyledMenuWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  ${respondTo.desktop`
     padding: 0 20px;
     display: flex;
     width: 100%;
     align-items: flex-start;
     flex-direction: row;
     height: 100%;
  `}
  ${respondTo.mobile`
    flex: 1;
  `}
`;

export const StyledFormContentWrapper = styled.div`
  padding: 0 20px 0 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex: 1;
  justify-content: space-between;
  margin-top: ${({ mt = 20 }) => mt}px;
  ${respondTo.desktop`
    padding: 40px 20px 0 20px;
    padding: 0;
    position: relative;
    margin-top: 0;
  `}
`;
